import React from 'react'
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import Layout from "./components/App";
import HomepageLayout from './components/layout/HomepageLayout';
import About from "./components/pages/about/About";
import Contact from "./components/pages/contact/Contact";
import Confirm from "./components/pages/contact/Confirm";
import Thanks from "./components/pages/contact/Thanks";
import PaymentFailed from "./components/pages/contact/PaymentFailed";
import PaymentError from "./components/pages/contact/PaymentError";
import Error from "./components/pages/error/Error";
import FaqPage from "./components/pages/faq/FaqPage";
import OnsiteWorkshop from "./components/pages/packageDetails/OnsiteWorkshop";
import OnlineWorkshop from "./components/pages/packageDetails/OnlineWorkshop";
import Residencies from "./components/pages/packageDetails/Residencies";
import Bundles from "./components/pages/packageDetails/Bundles";
import Plus7 from "./components/pages/packageDetails/Plus7";
import Jobs from "./components/pages/packageDetails/Jobs";
import Funding from "./components/pages/packageDetails/Funding";
import Subscribe from "./components/pages/Home/Subscribe";
import SubscribeConfirm from "./components/pages/Home/SubscribeConfirm";
import Terms from "./components/pages/packageDetails/Terms";
import Privacy from "./components/pages/packageDetails/Privacy";
import AllWorkshops from "./components/pages/packageSidebar/AllWorkshops";
import GalleryPage from "./components/pages/gallery/GalleryPage";
import SimpleReactLightbox from "simple-react-lightbox";
import { SessionProvider } from './components/common/SessionContext';

// import all css
import "./index.css";

function Root() {
  return (
    <>
      <BrowserRouter basename="/">
        <Switch>

          {/*main layout*/}
          <Route exact path="/" component={HomepageLayout} />

          {/* all inner page load layout component */}

          <Layout>

            <Route
              exact
              path={`${process.env.PUBLIC_URL}/about`}
              component={About}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/faq`}
              component={FaqPage}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/gallery`}
              component={GalleryPage}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/contact`}
              component={Contact}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/confirm/:ctype/:hash`}
              component={Confirm}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/thanks/:ctype/:hash`}
              component={Thanks}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/paymentfailed/:ctype/:hash`}
              component={PaymentFailed}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/paymenterror/:ctype/:hash`}
              component={PaymentError}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/error`}
              component={Error}
            />

            {/* all package pages component */}
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/workshops`}
              component={AllWorkshops}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/onsite/:item_id`}
              component={OnsiteWorkshop}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/online/:item_id`}
              component={OnlineWorkshop}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/residencies`}
              component={Residencies}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/bundles`}
              component={Bundles}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/plus7`}
              component={Plus7}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/jobs`}
              component={Jobs}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/funding`}
              component={Funding}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/subscribe`}
              component={Subscribe}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/subscribe/:ctype/:item_id`}
              component={Subscribe}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/subscribe_confirm/:item_id`}
              component={SubscribeConfirm}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/terms`}
              component={Terms}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/privacy`}
              component={Privacy}
            />

          </Layout>
        </Switch>
      </BrowserRouter>
    </>
  )
}

export default Root
ReactDOM.render(
  <React.StrictMode>
    <SimpleReactLightbox>
      <SessionProvider>
        <Root />
      </SessionProvider>
    </SimpleReactLightbox>
  </React.StrictMode>,
  document.getElementById("root")
);
